import Flickity from "flickity";
require('flickity-as-nav-for');

export default function () {

    const heroSlider = document.querySelector('.js-hero-slider');
    const carousels = document.querySelectorAll('.js-carousel');
    const multiSliderMain = document.querySelector('.js-multi-slider-main');
    const multiSliderNav = document.querySelector('.js-multi-slider-nav');
    const team = document.querySelectorAll('.teamBlock__items');
    const slides = document.querySelectorAll('.stripe__slider');
    const isMobile = window.innerWidth <= 768;

    // --- hero video player ---
    const video = document.querySelector(".js-hero-video");

    if (video) {
        const promise = video.play();
        if (promise !== undefined) {
            promise.then(() => {
                // Autoplay started
            }).catch(error => {
                // Autoplay was prevented.
                video.muted = true;
                video.play();
            });
        }
    }
    // --- // hero video player ---

    if (heroSlider) {
        new Flickity( heroSlider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: 5000,
            pageDots: true,
            prevNextButtons: false,
            pauseAutoPlayOnHover: true,
            imagesLoaded: true,
        });
    }

    carousels.forEach(function (elem, index) {
        if (elem) {
            new Flickity( elem, {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                autoPlay: 3000,
                imagesLoaded: true,
            });
        }
    });

    if (team) {
        team.forEach(function (elem, index) {
            if (elem) {

              const itemCount = elem.children.length;

                new Flickity( elem, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    imagesLoaded: true,
                    pageDots: itemCount > 1,
                    prevNextButtons: itemCount > 1 && !isMobile,
                });
            }
        });
    }

    if (slides) {
        slides.forEach(function (elem, index) {
            if (elem) {

                new Flickity( elem, {
                    cellAlign: 'center',
                    contain: true,       // Keeps slides within bounds
                    groupCells: 1,       // Ensures only one slide is shown at a time
                    wrapAround: true, 
                    autoPlay: 5000,
                    wrapAround: false,
                    pageDots: false,
                    prevNextButtons: false,
                });
            }
        });
    }

    if (multiSliderMain) {
        new Flickity( multiSliderMain, {
            pageDots: false,
            prevNextButtons: true,
            wrapAround: false,
            imagesLoaded: true,
        });
    }

    if (multiSliderNav) {
        new Flickity( multiSliderNav, {
            asNavFor: multiSliderMain,
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            imagesLoaded: true,
        });
    }

}
